export class HttpError extends Error {
  constructor(public readonly status: number, public readonly body?: string) {
    super(`HTTP error! status: ${status}`);
    this.name = 'HttpError';
  }
}